<template>
    <v-card>
        <v-form ref="treatmentForm" lazy-validation>
            <v-card-title>
                <span class="headline">TAGT</span>
            </v-card-title>
            <v-card-text>
                <v-container grid-list-md>
                    <v-layout wrap>
                        <v-flex xs12>
                            <v-text-field v-model="tagtPreop" label="TAGT pré-op" required></v-text-field>
                            <v-text-field v-model="tagtPostop" label="TAGT Post-op" required></v-text-field>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="secondary" @click="close">Annuler</v-btn>
                <v-btn color="primary" @click="update">Enregistrer</v-btn>
            </v-card-actions>
        </v-form>
    </v-card>
</template>

<script>
import {mapActions, mapState, mapMutations, mapGetters} from 'vuex'
    import {getTranslationString} from "../../../helper";

    export default {
        name: "TagtForm",
        created() {
        },
        computed: {
            tagtPreop: {
                get() {
                    return this.$store.state.treatments.tagtForm.tagt_preop
                },
                set(value) {
                    this.setTagtFormPreop(value)
                }
            },
            tagtPostop: {
                get() {
                    return this.$store.state.treatments.tagtForm.tagt_postop
                },
                set(value) {
                    this.setTagtFormPostop(value)
                }
            },
        },
        methods: {
            close() {
                this.setShowTagtForm(false)
            },
            update() {
                this.updateTagt().then(response => {
                    this.getTreatmentInfo();
                    this.setShowTagtForm(false);
                }).catch(reason => {
                    //Stay here..
                    this.setShowTagtForm(false);
                })
            },
            ...mapMutations('treatments', {
                setTagtFormPreop: 'setTagtFormPreop',
                setTagtFormPostop: 'setTagtFormPostop',
                setShowTagtForm: 'setShowTagtForm'
            }),
            ...mapActions('treatments', ['updateTagt', 'getTreatmentInfo']),
        }
    }
</script>
